// IQ Test Questions Database - Sample questions for offline use
// This file contains sample questions for when the API is not available

const questionsData = [
  {
    "type": "Arithmetic",
    "question": "What is 15 × 8?",
    "options": ["120", "125", "115", "130"],
    "answer": "120"
  },
  {
    "type": "Arithmetic", 
    "question": "What is 144 ÷ 12?",
    "options": ["12", "14", "10", "16"],
    "answer": "12"
  },
  {
    "type": "Arithmetic",
    "question": "What is 25% of 80?",
    "options": ["20", "25", "15", "30"],
    "answer": "20"
  },
  {
    "type": "Arithmetic",
    "question": "If a shirt costs $60 and is discounted by 25%, what is the final price?",
    "options": ["$45", "$40", "$50", "$35"],
    "answer": "$45"
  },
  {
    "type": "Arithmetic",
    "question": "What is 7² + 3²?",
    "options": ["58", "52", "49", "40"],
    "answer": "58"
  },
  {
    "type": "Numerical Reasoning",
    "question": "What comes next in the sequence: 2, 4, 8, 16, ?",
    "options": ["24", "32", "20", "28"],
    "answer": "32"
  },
  {
    "type": "Numerical Reasoning",
    "question": "What comes next in the sequence: 1, 4, 9, 16, 25, ?",
    "options": ["36", "30", "35", "40"],
    "answer": "36"
  },
  {
    "type": "Numerical Reasoning",
    "question": "What comes next in the sequence: 3, 6, 12, 24, ?",
    "options": ["48", "36", "30", "42"],
    "answer": "48"
  },
  {
    "type": "Numerical Reasoning",
    "question": "What comes next in the sequence: 2, 3, 5, 8, 13, ?",
    "options": ["21", "18", "20", "15"],
    "answer": "21"
  },
  {
    "type": "Numerical Reasoning",
    "question": "What comes next in the sequence: 100, 81, 64, 49, 36, ?",
    "options": ["25", "20", "30", "16"],
    "answer": "25"
  },
  {
    "type": "Logical Reasoning",
    "question": "All cats are animals. Some pets are cats. Therefore, some pets are animals.",
    "options": ["True", "False", "Cannot be determined", "Insufficient information"],
    "answer": "True"
  },
  {
    "type": "Logical Reasoning",
    "question": "If all birds can fly and penguins are birds, can penguins fly?",
    "options": ["Yes", "No", "Sometimes", "Cannot be determined"],
    "answer": "No"
  },
  {
    "type": "Logical Reasoning",
    "question": "All roses are flowers. Some plants are roses. Therefore, some plants are flowers.",
    "options": ["True", "False", "Cannot be determined", "Insufficient information"],
    "answer": "True"
  },
  {
    "type": "Logical Reasoning",
    "question": "If it rains, the ground gets wet. The ground is wet. Therefore, it rained.",
    "options": ["True", "False", "Cannot be determined", "Possibly true"],
    "answer": "False"
  },
  {
    "type": "Logical Reasoning",
    "question": "All students are people. Some learners are students. Therefore, some learners are people.",
    "options": ["True", "False", "Cannot be determined", "Insufficient information"],
    "answer": "True"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Book is to Reading as Fork is to:",
    "options": ["Eating", "Cooking", "Cutting", "Serving"],
    "answer": "Eating"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Car is to Road as Ship is to:",
    "options": ["Ocean", "Harbor", "Anchor", "Captain"],
    "answer": "Ocean"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Teacher is to Student as Doctor is to:",
    "options": ["Hospital", "Patient", "Medicine", "Nurse"],
    "answer": "Patient"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Key is to Lock as Password is to:",
    "options": ["Computer", "Security", "Login", "Account"],
    "answer": "Computer"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Pen is to Writing as Brush is to:",
    "options": ["Painting", "Art", "Canvas", "Color"],
    "answer": "Painting"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Which word means the same as 'Happy'?",
    "options": ["Joyful", "Sad", "Angry", "Tired"],
    "answer": "Joyful"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Which word means the same as 'Large'?",
    "options": ["Small", "Huge", "Medium", "Tiny"],
    "answer": "Huge"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Which word means the same as 'Quick'?",
    "options": ["Slow", "Fast", "Steady", "Calm"],
    "answer": "Fast"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Which word means the same as 'Difficult'?",
    "options": ["Easy", "Hard", "Simple", "Clear"],
    "answer": "Hard"
  },
  {
    "type": "Verbal Reasoning",
    "question": "Which word means the same as 'Beautiful'?",
    "options": ["Ugly", "Plain", "Gorgeous", "Average"],
    "answer": "Gorgeous"
  }
];

// Function to get a random set of questions for a test session
export function getRandomQuestions(count = 25) {
  // Create a copy of all questions to avoid modifying the original array
  const questionsCopy = [...questionsData];
  
  // Fisher-Yates shuffle algorithm for true randomization
  for (let i = questionsCopy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [questionsCopy[i], questionsCopy[j]] = [questionsCopy[j], questionsCopy[i]];
  }
  
  // Return the first 'count' questions from the shuffled array
  return questionsCopy.slice(0, count).map((q, index) => ({
    id: `q_${index + 1}`,
    type: q.type.toLowerCase().replace(' ', '_'),
    category: q.type,
    question: q.question,
    options: q.options,
    answer: q.answer, // Add the answer text for scoring
    correct: q.options.indexOf(q.answer),
    difficulty: "medium"
  }));
}

// Function to get total number of questions in database
export function getTotalQuestions() {
  return questionsData.length;
}

// Function to get questions by category
export function getQuestionsByCategory(category) {
  return questionsData.filter(q => q.type.toLowerCase() === category.toLowerCase());
}

// Export all questions for debugging purposes
export { questionsData as allQuestions };